<template>
    <div
        :class="disabled ? 'cursor-not-allowed opacity-50' : ''"
        class="flex min-h-12 items-center justify-between gap-1 rounded-lg border border-gray-200 px-6 py-1"
    >
        <div v-html="label" />
        <TimeField :disabled="disabled" :model-value="value" @update:model-value="emit('change', $event)" />
    </div>
</template>
<script setup>
import { TimeField } from '@/Components/ui/time-field';

defineProps({
    label: String,
    disabled: Boolean,
    value: { type: String, default: null },
});

const emit = defineEmits(['change']);
</script>
